import { Translation } from "../hooks/useTranslations";

const it: Translation = {
  languageCode: "it",
  projects: {
    addTo: "Aggiungi al progetto",
    all: "Tutti i progetti",
    new: "Nuovo progetto",
    singular: "Progetto",
    plural: "Progetti",
    my: "I miei progetti",
    createNew: "Crea nuovo progetto",
    infos: "Informazioni progetto",
    delete: "Elimina progetto",
    removeShared: "Rimuovi progetto condiviso",
    search: "Cerca progetti",
    shareWithUser: "Condividi progetto con utente",
    allowUserToEditSharedConfiguration: "Consenti all'utente di modificare la configurazione condivisa",
    allowUserToEditSharedProjectAndConfigurations:
      "Consenti all'utente di modificare il progetto condiviso e le configurazioni in esso contenute",
    editSharings: "Modifica condivisioni",
    invitation: "Invito al progetto",
    invitations: "Inviti al progetto",
    invite: "Invita al progetto",
    sharings: "Condivisioni del progetto",
    shared: "Progetto condiviso",
    sentAt: "Inviato",
    resendInvite: "Invia di nuovo l'invito",
    invitePage: {
      badge: "Invito di accesso al progetto",
      loadingProjectDetails: "Caricamento dettagli del progetto...",
      collaborationLead: "ti ha invitato a collaborare a questo progetto e a consultarne i contenuti condivisi.",
      projectName: "Nome progetto",
      inviteNoLongerAvailable:
        "Questo invito non e piu disponibile perche e gia stato accettato, rifiutato o annullato.",
      acceptSignedIn: "Accettando questo invito aprirai subito il progetto.",
      acceptSignedOut: "Accettando questo invito dovrai accedere prima di ottenere l'accesso al progetto.",
      inviteNotFound: "Questo invito non e stato trovato. Potrebbe essere stato rimosso oppure il link non e corretto.",
    },

    invitationStatus: {
      pending: "In attesa",
      active: "Attivo",
      accepted: "Accettato",
      rejected: "Rifiutato",
      cancelled: "Annullato",

      statusChanges: {
        rejected: "Invito rifiutato. Il tuo indirizzo email è stato reso anonimo e rimosso da questo progetto.",
        accept: "Invito accettato con successo",
      },
    },

    questions: {
      delete: "Vuoi davvero eliminare questo progetto?",
      unshare: "Vuoi davvero rimuovere la condivisione del progetto per questo utente?",
      cancelInvite: "Vuoi davvero annullare questo invito in sospeso?",
      removeShared:
        "Vuoi davvero rimuovere questo progetto dai tuoi progetti condivisi? Perderai l'accesso e questa azione non può essere annullata. Il progetto e le sue configurazioni non saranno interessati.",
    },

    errors: {
      deleteProjectWithConfigurationsNotPossible:
        "Non è possibile eliminare un progetto se sono presenti configurazioni.",
      deleteProjectWithDocumentsNotPossible: "Non è possibile eliminare un progetto se sono presenti document.",
      notFound: "Progetto non trovato.",
      sharingNotFound: "Condivisione non trovata.",
      sharingAlreadyExists: "Questo progetto e gia condiviso con questo utente.",
      inviteUpdateNotAllowed: "Non sei autorizzato ad accettare o rifiutare questo invito.",
      inviteAlreadyExists: "Esiste gia un invito per questo utente.",
      inviteAlreadyCancelled: "Questo invito e gia stato annullato.",
      inviteAlreadyAccepted: "Questo invito e gia stato accettato.",
      inviteAlreadyRejected: "Questo invito e gia stato rifiutato.",
      documentNotFound: "Documento non trovato.",
      missingDocumentName: "Nome del documento mancante.",
      documentAlreadyPresent: "Documento già presente.",
      missingProjectStatus: "Stato progetto mancante.",
    },
  },

  configurations: {
    all: "Tutte le configurazioni",
    new: "Nuova configurazione",
    plural: "Configurazioni",
    create: "Crea configurazione",
    createNew: "Crea nuova configurazione",
    delete: "Elimina configurazione",
    removeShared: "Rimuovi configurazione condivisa",
    duplicate: "Duplica configurazione",
    addToProject: "Aggiungi a progetto",
    unlinkFromProject: "Scollega dal progetto",
    my: "Le mie configurazioni",
    search: "Cerca configurazioni",
    reset: "Reimposta configurazione",

    questions: {
      delete: "Vuoi davvero eliminare questa configurazione?",
      reset: "Vuoi davvero reimpostare tutti i dati della configurazione attuale?",
      unlinkFromProject: "Vuoi davvero scollegare questa configurazione dal suo progetto?",
      removeShared:
        "Vuoi davvero rimuovere questa configurazione dalle tue configurazioni condivise? Perderai l'accesso e questa azione non può essere annullata. La configurazione non sarà interessata.",
    },

    invitePage: {
      badge: "Invito di accesso alla configurazione",
      loadingConfigurationDetails: "Caricamento dettagli della configurazione...",
      collaborationLead: "ti ha invitato a collaborare a questa configurazione e a consultarne i contenuti condivisi.",
      configurationName: "Nome configurazione",
      inviteNoLongerAvailable:
        "Questo invito non e piu disponibile perche e gia stato accettato, rifiutato o annullato.",
      acceptSignedIn: "Accettando questo invito aprirai subito la configurazione.",
      acceptSignedOut: "Accettando questo invito dovrai accedere prima di ottenere l'accesso alla configurazione.",
      inviteNotFound: "Questo invito non e stato trovato. Potrebbe essere stato rimosso oppure il link non e corretto.",
    },

    invitationStatus: {
      statusChanges: {
        rejected: "Invito rifiutato. Il tuo indirizzo email è stato reso anonimo e rimosso da questa configurazione.",
        accept: "Invito accettato con successo",
      },
    },

    errors: {
      notFound: "Configurazione non trovata.",
      missingNormative: "Normativa configurazione mancante.",
      missingSteelVersion: "Versione dell'acciaio configurazione mancante.",
      missingUpperSupportInstallationType: "Tipo di installazione supporto superiore configurazione mancante.",
      missingUpperSupport: "Supporto superiore configurazione mancante.",
      missingAbsorber: "Assorbitore configurazione mancante.",
      missingSystemType: "Tipo di sistema configurazione mancante.",
      missingCable: "Cavo configurazione mancante.",
      alreadyLinkedToProject: "Questa configurazione è già collegata a un progetto.",
      notLinkedToProject: "Questa configurazione non è collegata a un progetto.",
    },
  },

  documents: {
    add: "Aggiungi documento",
    all: "Tutti i documenti",
    alreadyPresent: "Documento già presente.",
    plural: "Documenti",
    delete: "Elimina documento",
    search: "Cerca documenti",

    questions: {
      delete: "Vuoi davvero eliminare questo documento?",
      overwrite: "Vuoi davvero sovrascrivere il documento già presente?",
    },

    errors: {
      someCouldNotBeSaved: "Alcuni documenti non sono stati salvati.",
    },
  },

  systems: {
    all: "Tutti i sistemi",
    new: "Nuovo sistema",
    singular: "Sistema",
    plural: "Sistemi",
    delete: "Elimina sistema",
    search: "Cerca sistemi",
    our: "I nostri sistemi",

    questions: {
      delete: "Vuoi davvero eliminare questo sistema?",
    },

    errors: {
      notFound: "Sistema non trovato.",
      inUseByConfiguration: "Il sistema è ancora in uso in una configurazione.",
    },
  },

  entityAccesses: {
    title: "Permessi utente",
    add: "Aggiungi permesso utente",
    accessColumn: "Accesso",
    questions: {
      remove: "Vuoi davvero rimuovere l'accesso di questo utente?",
    },
    errors: {
      alreadyExists: "Questo utente ha già un permesso per questo elemento.",
    },
  },

  users: {
    add: "Aggiungi utente",
    all: "Tutti gli utenti",
    iam: {
      label: "IAM",
      missing: "Mancante",
      valid: "Valido",
    },
    invite: "Invita utente",
    plural: "Utenti",
    remove: "Rimuovi utente",
    search: "Cerca utenti",
    usersEmail: "Email utente",
    usersName: "Nome utente",

    questions: {},

    errors: {
      notFound: "Utente non trovato.",
      notFoundInAccounts: "Utente non trovato in accounts.",
    },
  },

  items: {
    all: "Tutti gli elementi",
    singular: "Elemento",
    plural: "Elementi",
    createNew: "Crea nuovo elemento",
    delete: "Elimina elemento",
    search: "Cerca elementi",
    list: "Lista elementi",

    questions: {
      delete: "Vuoi davvero eliminare questo elemento?",
    },

    errors: {
      notFound: "Elemento non trovato.",
      doesNotExist: "L'articolo con questo codice non esiste.",
      missingCode: "Codice elemento mancante.",
    },
  },

  absorbers: {
    singular: "Assorbitore",
    plural: "Assorbitori",
    createNew: "Crea nuovo assorbitore",
    delete: "Elimina assorbitore",
    edit: "Modifica assorbitore",
    search: "Cerca assorbitori",
    removeFromSystem: "Rimuovi dal sistema",

    questions: {
      delete: "Vuoi davvero eliminare questo assorbitore?",
      removeFromSystem: "Vuoi davvero rimuovere l'assorbitore dal sistema?",
    },

    errors: {
      alreadyPresent: "Assorbitore già presente.",
      notFound: "Assorbitore non trovato.",
      noDefined: "Nessun assorbitore definito.",
      inUseByConfiguration: "L'assorbitore è ancora in uso in una configurazione.",
    },
  },

  cables: {
    createNew: "Crea nuovo cavo",
    delete: "Elimina cavo",
    edit: "Modifica cavo",
    search: "Cerca cavi",
    singular: "Cavo",
    plural: "Cavi",

    questions: {
      delete: "Vuoi davvero eliminare questo cavo?",
    },

    errors: {
      alreadyPresent: "Cavo già presente.",
      notFound: "Cavo non trovato.",
      noDefined: "Nessun cavo definito.",
      inUseByConfiguration: "Il cavo è ancora in uso in una configurazione.",
    },
  },

  handles: {
    addItemAsVertigrip: "Aggiungi elemento come maniglia Vertigrip",
    delete: "Elimina maniglia",
    edit: "Modifica maniglia",
    singular: "Maniglia",
    plural: "Maniglie",
    search: "Cerca maniglie",
    noHandle: "Nessuna maniglia",

    questions: {
      delete: "Vuoi davvero eliminare questa maniglia?",
    },

    errors: {
      alreadyPresent: "Maniglia già presente.",
      notFound: "Maniglia non trovata.",
      inUseByConfiguration: "La maniglia è ancora in uso in una configurazione.",
      inUseByUpperExtension: "La maniglia è ancora in uso in un'estensione superiore.",
    },
  },

  intermediateElements: {
    createNew: "Crea nuovo elemento intermedio",
    delete: "Elimina elemento intermedio",
    edit: "Modifica elemento intermedio",
    singular: "Elemento intermedio",
    plural: "Elementi intermedi",
    search: "Cerca elementi intermedi",

    questions: {
      delete: "Vuoi davvero eliminare questo elemento intermedio?",
    },

    errors: {
      alreadyPresent: "Elemento intermedio già presente.",
      notFound: "Elemento intermedio non trovato.",
      inUseByConfiguration: "L'elemento intermedio è ancora in uso in una configurazione.",
    },
  },

  ladderReinforcements: {
    createNew: "Crea nuovo rinforzo per scale",
    delete: "Elimina rinforzo per scale",
    edit: "Modifica rinforzo per scale",
    singular: "Rinforzo per scale",
    plural: "Rinforzi per scale",
    search: "Cerca rinforzi per scale",
    noLadderReinforcement: "Nessun rinforzo per scale",

    questions: {
      delete: "Vuoi davvero eliminare questo rinforzo per scale?",
    },

    errors: {
      alreadyPresent: "Rinforzo per scale già presente.",
      notFound: "Rinforzo per scale non trovato.",
      inUseByConfiguration: "Rinforzo per scale è ancora in uso in una configurazione.",
    },
  },

  wallMaterials: {
    createNew: "Crea nuovo materiale pareti",
    delete: "Elimina materiale pareti",
    singular: "Materiale pareti",
    plural: "Materiali pareti",
    search: "Cerca materiali pareti",
    noWallMaterial: "Nessun materiale pareti",

    questions: {
      delete: "Vuoi davvero eliminare questo materiale pareti?",
    },

    errors: {
      notFound: "Materiale pareti non trovato.",
      inUseByConfiguration: "Materiale pareti è ancora in uso in una configurazione.",
    },
  },

  wallMaterialFixings: {
    createNew: "Crea nuovo fissaggio",
    delete: "Elimina fissaggio",
    singular: "Fissaggio",
    plural: "Fissaggi",
    search: "Cerca fissaggi",

    questions: {
      delete: "Vuoi veramente eliminare questo fissaggio?",
    },

    errors: {
      notFound: "Fissaggio non trovato.",
      inUseByConfiguration: "Fissaggio in uso da una configurazione.",
    },
  },

  wallMaterialFixingItems: {
    errors: {
      alreadyPresent: "Elemento di fissaggio già presente.",
    },
  },

  lowerElements: {
    createNew: "Crea nuovo elemento inferiore",
    delete: "Elimina elemento inferiore",
    edit: "Modifica elemento inferiore",
    singular: "Elemento inferiore",
    plural: "Elementi inferiori",
    search: "Cerca elementi inferiori",

    questions: {
      delete: "Vuoi veramente eliminare questo elemento inferiore?",
    },

    errors: {
      alreadyPresent: "Elemento inferiore già presente.",
      notFound: "Elemento inferiore non trovato.",
      inUseByConfiguration: "Elemento inferiore in uso da una configurazione.",
    },
  },

  shuttles: {
    addItemAsVertigrip: "Aggiungi elemento come una navetta Vertigrip",
    addItemAsPatrol: "Aggiungi elemento come una navetta Patrol",
    delete: "Elimina navetta",
    edit: "Modifica navetta",
    singular: "Navetta",
    plural: "Navette",
    search: "Cerca navette",
    no: "Nessuna navetta",

    questions: {
      delete: "Vuoi veramente eliminare questa navetta?",
    },

    errors: {
      alreadyPresent: "Navetta già presente.",
      notFound: "Navetta non trovata.",
      inUseByConfiguration: "Navetta in uso da una configurazione.",
    },
  },

  installationTypes: {
    plural: "Tipi d'installazione",
    singular: "Tipo d'installazione",
    search: "Cerca tipi d'installazione",

    questions: {
      delete: "Vuoi veramente eliminare questo tipo d'installazione?",
    },

    errors: {
      notFound: "Tipo d'installazione non trovato.",
      inUseByConfiguration: "Tipo d'installazione in uso da una configurazione.",
      inUseByUpperExtension: "Tipo d'installazione in uso da un estensione superiore.",
      inUseByLowerElement: "Tipo d'installazione in uso da un elemento inferiore.",
      inUseByIntermediateElement: "Tipo d'installazione in uso da un elemento intermedio.",
      inUseByLadderReinforcement: "Tipo d'installazione in uso da un rinfozo per scale.",
    },
  },

  steelVersions: {
    createNew: "Crea nuova versione d'acciaio",
    delete: "Elimina versione d'acciaio",
    singular: "Versione d'acciaio",
    plural: "Versioni d'acciaio",
    search: "Cerca versioni d'acciaio",

    questions: {
      delete: "Vuoi veramente eliminare questa versione d'acciaio?",
    },

    errors: {
      notFound: "Versione d'acciaio non trovata.",
      inUseByConfiguration: "Versione d'acciaio in uso da una configurazione.",
      inUseByUpperExtension: "Versione d'acciaio in uso da un estensione superiore.",
      inUseByLowerElement: "Versione d'acciaio in uso da un elemento inferiore.",
      inUseByIntermediateElement: "Versione d'acciaio in uso da un elemento intermedio.",
      inUseByAsorber: "Versione d'acciaio in uso da un assorbitore.",
      inUseBySupport: "Versione d'acciaio è ancora utilizzata da un supporto.",
      inUseByCurvesIntermediate: "Versione d'acciaio è ancora utilizzata da un intermedio/curva.",
      inUseByTerminal: "Versione d'acciaio è ancora utilizzata da un terminale.",
      inUseByShuttle: "Versione d'acciaio è ancora utilizzata da una navetta.",
      inUseByAnchorMapping: "Versione d'acciaio è ancora utilizzata da una mappatura di ancoraggio.",
      inUseByConfigurationAnchorPoint:
        "Versione d'acciaio è ancora utilizzata da un punto di ancoraggio di configurazione.",
    },
    warnings: {
      deleteWarning: "Eliminare questi dati influenzerà altri moduli/configurazioni.",
      editWarning: "Modificare questi dati influenzerà altri moduli/configurazioni.",
    },
  },

  upperExtensions: {
    createNew: "Crea nuova estensione superiore",
    delete: "Elimina estensione superiore",
    edit: "Modifica estensione superiore",
    singular: "Estensione superiore",
    plural: "Estensioni superiori",
    search: "Cerca estensioni superiori",

    questions: {
      delete: "Vuoi veramente eliminare questa estensione superiore?",
    },

    errors: {
      alreadyPresent: "Estensione superiore già presente.",
      notFound: "Estensione superiore non trovata.",
      noDefined: "Nessuna estensione superiore definita.",
      inUseByConfiguration: "Estensione superiore in uso da una configurazione.",
    },
  },

  normatives: {
    createNew: "Crea nuova normativa",
    delete: "Elimina normativa",
    singular: "Normativa",
    plural: "Normative",
    search: "Cerca normative",
    add: "Aggiungi normativa",

    questions: {
      delete: "Vuoi veramente eliminare questa normativa?",
    },

    errors: {
      notFound: "Normativa non trovata.",
      noDefined: "Nessuna normativa definita.",
      inUseByConfiguration: "Normativa in uso da una configurazione.",
    },
  },

  systemTypes: {
    singular: "Tipo di sistema",
    plural: "Tipi di sistema",
    search: "Cerca tipi di sistema",

    questions: {
      delete: "Vuoi veramente eliminare questo tipo di sistema?",
    },

    errors: {
      notFound: "Tipo di sistema non trovato.",
      inUseByConfiguration: "Tipo di sistema in uso da una configurazione.",
      inUseByShuttle: "Tipo di sistema in uso da una navetta.",
      inUseByIntermediateElement: "Tipo di sistema in uso da un elemento intermedio.",
    },
  },

  texts: {
    singular: "Testo",
    plural: "Testi",
    search: "Cerca testi",

    questions: {
      delete: "Vuoi veramente eliminare questo testo?",
    },

    errors: {
      alreadyPresent: "Testo già presente.",
      notFound: "Testo non trovato.",
      missingId: "Id testo mancante.",
      missingValue: "Valore testo mancante.",
    },
  },

  clients: {
    all: "Tutti gli client",
    plural: "Client",
    createNew: "Crea nuovo client",
    delete: "Elimina client",
    search: "Cerca client",

    questions: {
      delete: "Vuoi davvero eliminare questo client?",
    },

    errors: {
      notFound: "Client non trovato.",
      insertNotAllowed: "Non sei autorizzato ad inserire un nuovo client.",
      readNotAllowed: "Non sei autorizzato a leggere questo client.",
      updateNotAllowed: "Non sei autorizzato ad aggiornare questo client.",
      deleteNotAllowed: "Non sei autorizzato ad eliminare questo client.",
    },
  },

  roles: {
    plural: "Ruoli",
  },

  permissions: {
    plural: "Permessi",
  },

  secrets: {
    plural: "Secret",

    errors: {
      missingValue: "Valore secret mancante.",
    },
  },

  substructures: {
    createNew: "Crea nuova sottostruttura",
    delete: "Elimina sottostruttura",
    singular: "Sottostruttura",
    plural: "Sottostrutture",
    single: "Sottostruttura",
    search: "Cerca sottostrutture",
    edit: "Modifica sottostruttura",

    questions: {
      delete: "Vuoi davvero eliminare questa sottostruttura?",
    },
  },

  bases: {
    createNew: "Crea nuova base",
    delete: "Elimina base",
    singular: "Base",
    plural: "Basi",
    search: "Cerca basi",
    edit: "Modifica base",
    add: "Aggiungi base",

    questions: {
      delete: "Vuoi davvero eliminare questa base?",
    },

    errors: {
      alreadyPresent: "Base già presente",
      notFound: "Base non trovato",
    },
  },

  ballasts: {
    createNew: "Crea nuova zavorra",
    delete: "Elimina zavorra",
    singular: "Zavorra",
    plural: "Zavorre",
    search: "Cerca zavorre",
    edit: "Modifica zavorra",
    add: "Aggiungi zavorra",

    questions: {
      delete: "Vuoi davvero eliminare questa zavorra?",
    },

    errors: {
      alreadyPresent: "Zavorra già presente",
      notFound: "Zavorra non trovato",
    },
  },

  ballastTypes: {
    createNew: "Crea nuovo tipo di zavorra",
    delete: "Elimina tipo di zavorra",
    singular: "Tipo di zavorra",
    plural: "Tipi di zavorra",
    search: "Cerca tipi di zavorra",
    edit: "Modifica tipo di zavorra",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo di zavorra?",
    },

    errors: {
      missingName: "Nome tipo di zavorra mancante",
      notFound: "Tipo di zavorra non trovato",
    },
  },

  uprights: {
    createNew: "Crea nuovo montante",
    delete: "Elimina montante",
    singular: "Montante",
    plural: "Montanti",
    search: "Cerca montanti",
    edit: "Modifica montante",
    add: "Aggiungi montante",

    questions: {
      delete: "Vuoi davvero eliminare questo montante?",
    },

    errors: {
      alreadyPresent: "Montante già presente",
      notFound: "Montante non trovato",
    },
  },

  uprightTypes: {
    createNew: "Crea nuovo tipo di montante",
    delete: "Elimina tipo di montante",
    singular: "Tipo di montante",
    plural: "Tipi di montante",
    search: "Cerca tipi di montante",
    edit: "Modifica tipo di montante",
    add: "Aggiungi tipo di montante",

    questions: {
      delete: "Vuoi davvero eliminare questo tipo di montante?",
    },

    errors: {
      missingName: "Il nome del tipo di montante è obbligatorio",
      notFound: "Tipo di montante non trovato",
      inUseByUprights: "Il tipo di montante è ancora usato da uno o più montanti",
    },
  },

  guardrailCompositions: {
    createNew: "Crea nuova composizione parapetto",
    delete: "Elimina composizione parapetto",
    singular: "Composizione parapetto",
    plural: "Composizioni parapetto",
    search: "Cerca composizioni parapetto",
    edit: "Modifica composizione parapetto",
    add: "Aggiungi composizione parapetto",

    questions: {
      delete: "Vuoi davvero eliminare questa composizione parapetto?",
    },

    errors: {
      missingName: "Nome composizione parapetto mancante",
      notFound: "Composizione parapetto non trovata",
    },
  },

  rails: {
    createNew: "Crea nuovo corrimano",
    delete: "Elimina corrimano",
    singular: "Corrimano",
    plural: "Corrimani",
    search: "Cerca Corrimani",
    edit: "Modifica corrimano",
    add: "Aggiungi corrimano",

    questions: {
      delete: "Vuoi davvero eliminare questo corrimano?",
    },

    errors: {
      alreadyPresent: "Corrimano già presente",
      notFound: "Corrimano non trovato",
    },
  },

  toeBoards: {
    createNew: "Crea nuova tavola fermapiede",
    delete: "Elimina tavola fermapiede",
    singular: "Tavola fermapiede",
    plural: "Tavole fermapiede",
    search: "Cerca tavole fermapiede",
    edit: "Modifica tavola fermapiede",
    add: "Aggiungi tavola fermapiede",

    questions: {
      delete: "Vuoi davvero eliminare questa tavola fermapiede?",
    },

    errors: {
      alreadyPresent: "Tavola fermapiede già presente",
      notFound: "Tavola fermapiede non trovata",
    },
  },

  toeBoardExtras: {
    createNew: "Crea nuova tavola fermapiede extra",
    delete: "Elimina tavola fermapiede extra",
    singular: "Tavola fermapiede extra",
    plural: "Tavole fermapiede extra",
    search: "Cerca tavole fermapiede extra",
    edit: "Modifica tavola fermapiede extra",
    add: "Aggiungi tavola fermapiede extra",

    questions: {
      delete: "Vuoi davvero eliminare questa tavola fermapiede extra?",
    },

    errors: {
      alreadyPresent: "Tavola fermapiede extra già presente",
      notFound: "Tavola fermapiede extra non trovata",
    },
  },

  uprightCaps: {
    createNew: "Crea nuovo tappo montante",
    delete: "Elimina tappo montante",
    singular: "Tappo montante",
    plural: "Tappi montante",
    search: "Cerca cappucci montante",
    edit: "Modifica tappo montante",
    add: "Aggiungi tappo montante",

    questions: {
      delete: "Vuoi davvero eliminare questo tappo montante?",
    },

    errors: {
      alreadyPresent: "Tappo montante già presente",
      notFound: "Tappo montante non trovato",
    },
  },

  railCaps: {
    createNew: "Crea nuovo tappo per il corrimano",
    delete: "Elimina tappo per il corrimano",
    singular: "Tappo per il corrimano",
    plural: "Tappi per il corrimano",
    search: "Cerca tappi per il corrimano",
    edit: "Modifica tappo per il corrimano",
    add: "Aggiungi tappo per il corrimano",

    questions: {
      delete: "Vuoi davvero eliminare questo tappo per il corrimano?",
    },

    errors: {
      alreadyPresent: "Tappo per il corrimano già presente",
      notFound: "Tappo per il corrimano non trovato",
    },
  },

  railWallFixings: {
    createNew: "Crea nuovo fissaggio a parete per il corrimano",
    delete: "Elimina fissaggio a parete per il corrimano",
    singular: "Fissaggio a parete per il corrimano",
    plural: "Fissaggi a parete per il corrimano",
    search: "Cerca fissaggi a parete per il corrimano",
    edit: "Modifica fissaggio a parete per il corrimano",
    add: "Aggiungi fissaggio a parete per il corrimano",

    questions: {
      delete: "Vuoi davvero eliminare questo fissaggio a parete per il corrimano?",
    },

    errors: {
      alreadyPresent: "Fissaggio a parete per il corrimano già presente",
      notFound: "Fissaggio a parete per il corrimano non trovato",
    },
  },

  railCorners: {
    createNew: "Crea nuovo angolo per il corrimano",
    delete: "Elimina angolo per il corrimano",
    singular: "Angolo per il corrimano",
    plural: "Angoli per il corrimano",
    search: "Cerca angoli per il corrimano",
    edit: "Modifica angolo per il corrimano",
    add: "Aggiungi angolo per il corrimano",

    questions: {
      delete: "Vuoi davvero eliminare questo angolo per il corrimano?",
    },

    errors: {
      alreadyPresent: "Angolo per il corrimano già presente",
      notFound: "Angolo per il corrimano non trovato",
    },
  },

  gates: {
    createNew: "Crea nuovo cancello",
    delete: "Elimina cancello",
    singular: "Cancello",
    plural: "Cancelli",
    search: "Cerca cancelli",
    edit: "Modifica cancello",
    add: "Aggiungi cancello",

    questions: {
      delete: "Vuoi davvero eliminare questo cancello?",
    },

    errors: {
      alreadyPresent: "Cancello già presente",
      notFound: "Cancello non trovato",
    },
  },

  waterproofKits: {
    createNew: "Crea nuovo kit impermeabile",
    delete: "Elimina kit impermeabile",
    singular: "Kit impermeabile",
    plural: "Kit impermeabili",
    search: "Cerca kit impermeabili",
    edit: "Modifica kit impermeabile",
    add: "Aggiungi kit impermeabile",

    questions: {
      delete: "Vuoi davvero eliminare questo kit impermeabile?",
    },

    errors: {
      alreadyPresent: "Kit impermeabile già presente",
      notFound: "Kit impermeabile non trovato",
    },
  },

  fastenings: {
    singular: "Fissaggio",
  },

  fasteningChoices: {
    createNew: "Crea nuova combinazione fissaggi",
    delete: "Elimina combinazione fissaggi",
    edit: "Modifica combinazione fissaggi",
    singular: "Combinazione fissaggi",
    plural: "Combinazioni fissaggi",
    search: "Cerca combinazioni fissaggi",
    combination: "Combinazione",
    factorPerUpright: "Fattore per montante",

    questions: {
      delete: "Vuoi davvero eliminare questa combinazione fissaggi?",
    },

    errors: {
      alreadyPresent: "Combinazione fissaggi già presente",
      duplicateFastening: "Fissaggio duplicato selezionato",
      notFound: "Combinazione fissaggi non trovata",
    },
  },

  membraneProtections: {
    createNew: "Crea nuova membrana protettiva",
    delete: "Elimina membrana protettiva",
    singular: "Membrana protettiva",
    plural: "Membrane protettive",
    search: "Cerca membrane protettive",
    edit: "Modifica membrana protettiva",
    add: "Aggiungi membrana protettiva",

    questions: {
      delete: "Vuoi davvero eliminare questa membrana protettiva?",
    },

    errors: {
      alreadyPresent: "Membrana protettiva già presente",
      notFound: "Membrana protettiva non trovata",
    },
  },

  workMethods: {
    singular: "Metodo di lavoro",
    plural: "Metodi di lavoro",
    deleteLabel: "metodo di lavoro",
    new: "Nuovo metodo di lavoro",
    edit: "Modifica metodo di lavoro",
    delete: "Elimina metodo di lavoro",
    search: "Cerca metodi di lavoro",
  },
  supports: {
    singular: "Supporto",
    plural: "Supporti",
    deleteLabel: "supporto",
    new: "Nuovo supporto",
    edit: "Modifica supporto",
    delete: "Elimina supporto",
    search: "Cerca supporti",
  },
  labelLanguages: {
    singular: "Lingua etichetta",
    plural: "Lingue etichetta",
    deleteLabel: "lingua etichetta",
    new: "Nuova lingua etichetta",
    edit: "Modifica lingua etichetta",
    delete: "Elimina lingua etichetta",
    search: "Cerca lingue etichetta",
  },
  towers: {
    singular: "Torre",
    plural: "Torri",
    deleteLabel: "torre",
    new: "Nuova torre",
    edit: "Modifica torre",
    delete: "Elimina torre",
    search: "Cerca torri",
  },
  trolleys: {
    singular: "Carrello",
    plural: "Carrelli",
    deleteLabel: "carrello",
    new: "Nuovo carrello",
    edit: "Modifica carrello",
    delete: "Elimina carrello",
    search: "Cerca carrelli",
  },
  railCurves: {
    singular: "Curva binario",
    plural: "Curve binario",
    deleteLabel: "curva binario",
    new: "Nuova curva binario",
    edit: "Modifica curva binario",
    delete: "Elimina curva binario",
    search: "Cerca curve binario",
  },
  railJunctions: {
    singular: "Giunzione binario",
    plural: "Giunzioni binario",
    deleteLabel: "giunzione binario",
    new: "Nuova giunzione binario",
    edit: "Modifica giunzione binario",
    delete: "Elimina giunzione binario",
    search: "Cerca giunzioni binario",
  },
  railTerminals: {
    singular: "Terminale binario",
    plural: "Terminali binario",
    deleteLabel: "terminale binario",
    new: "Nuovo terminale binario",
    edit: "Modifica terminale binario",
    delete: "Elimina terminale binario",
    search: "Cerca terminali binario",
  },
  screws: {
    singular: "Vite",
    plural: "Viti",
    deleteLabel: "vite",
    new: "Nuova vite",
    edit: "Modifica vite",
    delete: "Elimina vite",
    search: "Cerca viti",
  },
  tools: {
    singular: "Attrezzo",
    plural: "Attrezzi",
    deleteLabel: "attrezzo",
    new: "Nuovo attrezzo",
    edit: "Modifica attrezzo",
    delete: "Elimina attrezzo",
    search: "Cerca attrezzi",
  },
  fasteningOptions: {
    singular: "Opzione di fissaggio",
    plural: "Opzioni di fissaggio",
    deleteLabel: "opzione di fissaggio",
    new: "Nuova opzione di fissaggio",
    edit: "Modifica opzione di fissaggio",
    delete: "Elimina opzione di fissaggio",
    search: "Cerca opzioni di fissaggio",
  },
  fasteningOptionItems: {
    singular: "Elemento opzione di fissaggio",
    plural: "Elementi opzione di fissaggio",
    deleteLabel: "elemento opzione di fissaggio",
    new: "Nuovo elemento opzione di fissaggio",
    edit: "Modifica elemento opzione di fissaggio",
    delete: "Elimina elemento opzione di fissaggio",
    search: "Cerca elementi opzione di fissaggio",
  },
  itemExtras: {
    singular: "Elemento extra",
    plural: "Extra",
    deleteLabel: "elemento extra",
    new: "Nuovo elemento extra",
    edit: "Modifica elemento extra",
    delete: "Elimina elemento extra",
    search: "Cerca extra",
  },
  supportItems: {
    singular: "Elemento di supporto",
    plural: "Elementi di supporto",
    deleteLabel: "elemento di supporto",
    new: "Nuovo elemento di supporto",
    edit: "Modifica elemento di supporto",
    delete: "Elimina elemento di supporto",
    search: "Cerca elementi di supporto",
  },
  systemSupportOptions: {
    singular: "Opzione supporto del sistema",
    plural: "Opzioni supporto del sistema",
    deleteLabel: "opzione supporto del sistema",
    new: "Nuova opzione supporto del sistema",
    edit: "Modifica opzione supporto del sistema",
    delete: "Elimina opzione supporto del sistema",
    search: "Cerca opzioni supporto del sistema",
  },

  common: {
    active: "Attivo",
    accept: "Accetta",
    add: "Aggiungi",
    addNewItem: "Aggiungi nuovo elemento",
    address: "Indirizzo",
    administration: "Amministrazione",
    allow: "Consenti",
    deny: "Nega",
    shared: "Condiviso",
    canEdit: "Può modificare",
    alreadyPresent: "Già presente/i",
    general: "Generale",
    itemDependencies: "Dipendenze articoli",
    millimeters: " mm",
    deduction: "Detrazione",
    nominalAngle: "Angolo nominale",
    deflection: "Deflessione",
    horizontalDeduction: "Detrazione orizzontale",
    internalDeduction: "Detrazione interna",
    externalDeduction: "Detrazione esterna",
    doubleTerminal: "Terminale doppio",
    doubleTerminalVisible: "Terminale doppio visibile",
    factorPerFasteningPoint: "Fattore per punto di fissaggio",
    factorPerLabel: "Fattore per etichetta",
    fasteningOption: "Opzione di fissaggio",
    fasteningPoints: "Punti di fissaggio",
    fasteningPointsPerSupport: "Punti di fissaggio per supporto",
    floor: "Pavimento",
    overhead: "Sospeso",
    wall: "Parete",
    none: "Nessuno",
    required: "Obbligatorio",
    horizontal: "Orizzontale",
    vertical: "Verticale",
    terminalTypeClosed: "Chiuso",
    terminalTypeOpen: "Aperto",
    jointHoleTemplateVisible: "Template fori giunzione visibile",
    jointTemplate: "Template giunzione",
    junctions: "Giunzioni",
    junctionsRequired: "Giunzioni richieste",
    mountingContext: "Contesto di montaggio",
    plane: "Piano",
    quantity: "Quantità",
    quantityPerItem: "Quantità per articolo",
    quantityPerSupport: "Quantità per supporto",
    supportsRequired: "Supporti richiesti",
    hrailSupport: "Supporto",
    systemHeader: (title: string) => `Sistema: ${title}`,
    terminalType: "Tipo terminale",
    tower: "Torre",
    workMethod: "Metodo di lavoro",
    fasteningOptionHeader: (title: string) => `Opzione di fissaggio: ${title}`,
    deleteEntityQuestion: (entity: string, label: string) => `Eliminare ${entity} "${label}"?`,
    archived: "Archiviato",
    atLeastOneItemNeeded: "É necessario almeno un elemento.",
    author: "Autore",
    automaticSync: "Sync automatico",
    back: "Indietro",
    baseOrientation: "Orientamento di base",
    cornerClassification: "Classificazione angolo",
    baseHeight: "Altezza base",
    breadcrumb: "Percorso di navigazione",
    cancel: "Annulla",
    close: "Chiudi",
    city: "Città",
    code: "Codice",
    company: "Impresa",
    confirmed: "Confermato",
    offer: "Offerta",
    contactPerson: "Persona di contatto",
    contactPersonWarning:
      "L'inserimento di questo dato è volontario e sotto la completa responsabilità dell'Utente. Si sconsiglia di inserire dati che identificano o che rendano identificabili persone.",
    cookiePolicy: "Cookie Policy",
    coordinates: "Coordinate",
    copy: "Copia",
    corners: "Angoli",
    corrugationSpan: "Larghezza dell'ondulazione",
    curb: "Cordolo",
    curbHeight: "Altezza cordolo",
    curbDepth: "Profondità cordolo",
    curbHeightBelowMinimum: (value: number) => `L'altezza minima del cordolo per questa selezione è ${value} mm`,
    curbDepthBelowBaseHeight: (value: number) =>
      `La profondità del cordolo deve essere di almeno ${value} mm per ospitare la base selezionata`,
    country: "Paese",
    create: "Crea",
    created: "Creato",
    createNew: "Crea nuovo",
    curved: "Curvo",
    currentRoofDoesNotAllowAnchorPoints:
      "La configurazione attuale del tetto non è adatta per punti di ancoraggio singoli.",
    dataHasBeenSavedSuccessfully: "I dati sono stati salvati correttamente.",
    date: "Data",
    decrease: (value: number) => `Decrementa ${value}`,
    download: "Scarica",
    delete: "Elimina",
    description: "Descrizione",
    descriptionLong: "Descrizione (lunga)",
    descriptionShort: "Descrizione (corta)",
    details: "Dettagli",
    distance: "Distanza",
    diameter: "Diametro",
    dragAndDropOrUploadAnImage: "Trascina e rilascia o clicca per carica un'immagine",
    dropIt: "Rilascialo!",
    duplicate: "Duplica",
    edit: "Modifica",
    writePermissions: "Permessi di scrittura",
    permissionToEdit: "Permesso di modificare",
    editor: "Editore",
    email: "E-mail",
    error: "Errore",
    errorLoadingData: "Errore caricamento dati",
    excel: "Excel",
    failed: "Fallito/i",
    fieldCannotBeEmpty: "Il campo non può essere vuoto.",
    fieldContainsInvalidValueInsertBiggerOne: "Il campo contiene un valore non valido, inserirne uno più grande.",
    fieldContainsInvalidValueInsertSmallerOne: "Il campo contiene un valore non valido, inserirne uno più piccolo.",
    fieldValueInvalidFormat: "Il valore ha un formato non valido.",
    fieldInvalidValue: "Il campo contiene un valore non valido.",
    fixed: "Fisso",
    forbidden: "Non consentito",
    generalData: "Dati generali",
    genericError: "Si è verificato un errore, si prega di riprovare.",
    guardrailComposition: "Composizione parapetto",
    heightToReach: "Altezza da raggiuingere",
    hidden: "Nascosto",
    home: "Home",
    increase: (value: number) => `Incrementa ${value}`,
    installed: "Installato",
    intermediateSupport: "Supporto intermedio",
    isVisible: "È visibile",
    isBallastRequired: "È richiesto il ballast",
    isFasteningVisible: "Il fissaggio è visibile",
    isGateVisible: "Il cancello è visibile",
    isHighWindVisible: "Alta resistenza al vento visibile",
    isIntermediateBarRequired: "È richiesto il corrente intermedio",
    isSubstructureRequired: "È richiesta la sottostruttura",
    isSubstructureDetailsRequired: "Dettagli della sottostruttura richiesti",
    isPerimeterSplitRequired: "Suddivisione del perimetro richiesta",
    isCornerOrientationRequired: "Orientamento degli angoli richiesto",
    isReclinableUpright: "È ribaltabile",
    isCurbVisible: "Cordolo visibile",
    isCurbDepthVisible: "Profondità cordolo visibile",
    isReinforced: "È rinforzato",
    isToeBoardRequired: "È richiesta la tavola fermapiede",
    isVertical: "È verticale",
    isVerticalBaseTypeRequired: "È richiesto un tipo di base verticale",
    isWaterproofKitVisible: "Il kit di impermeabilizzazione è visibile",
    isWedgeVisible: "Il cuneo è visibile",
    visibility: "Visibilità",
    rothoblaasUsers: "Utenti Rothoblaas",
    externalUsers: "Utenti esterni",
    everyOne: "Tutti",
    ladderExitDifference: "Differenza uscita scala",
    translations: "Traduzioni",
    appLanguage: "Lingua dell'app",
    languages: {
      singular: "Lingua",
      plural: "Lingue",
      arabic: "Arabo",
      czech: "Ceco",
      danish: "Danese",
      german: "Tedesco",
      greek: "Greco",
      english: "Inglese",
      spanish: "Spagnolo",
      estonian: "Estone",
      finnish: "Finlandese",
      french: "Francese",
      croatian: "Croato",
      hungarian: "Ungherese",
      icelandic: "Islandese",
      italian: "Italiano",
      japanese: "Giapponese",
      lithuanian: "Lituano",
      latvian: "Lettone",
      dutch: "Olandese",
      norwegian: "Norvegese",
      polish: "Polacco",
      portugese: "Portoghese",
      russian: "Russo",
      slovak: "Slovacco",
      slovenian: "Sloveno",
      swedish: "Svedese",
      turkish: "Turco",
      chinese: "Cinese",
      korean: "Coreano",
    },
    firstName: "Nome",
    lastAccess: "Ultimo accesso",
    lastModified: "Ultima modifica",
    lastName: "Cognome",
    lastSync: "Ultimo sync",
    left: "Sinistra",
    loading: "Caricamento...",
    location: "Luogo",
    login: "Login",
    logout: "Logout",
    lowerSupport: "Supporto inferiore",
    lowerHoleDiameter: "Diametro del foro inferiore",
    minimumConfigurableQuantity: "Quantità minima configurabile",
    minimumOrderQuantity: "Quantità minima ordinabile",
    minOrderQuantity: "Qtà min. ordinabile",
    myArea: "La mia area",
    myProfile: "Il Mio Profilo",
    name: "Nome",
    next: "Avanti",
    never: "mai",
    newConfigurationName: "Nuovo nome configurazione",
    nextNRows: (n: number) => `${n} righe successive`,
    no: "No",
    noItemsFound: "Nessun elemento trovato",
    notFound: "Non trovato",
    nrBallastIntermediate: "Nr. zavorre intermedie",
    nrBallastTerminal: "Nr. zavorre terminali",
    nrIntermediatesAndSpan: "Nr. intermedi e intervallo",
    nrRivets: "Nr. rivetti",
    nrOfFixingItemsRequired: "Numero di elementi di fissaggio richiesti (per materiale da parete)",
    ok: "Ok",
    onlyImagesAreAllowed: "Sono ammesse solo immagini.",
    open: "Apri",
    optional: "opzionale",
    order: "Ordinamento",
    overwrite: "Sovrascrivere",
    previousNRows: (n: number) => `${n} righe precedenti`,
    print: "Stampa",
    privacyPolicy: "Informativa sulla privacy",
    qty: "Qtà.",
    reject: "Rifiuta",
    removable: "Rimovibile",
    rename: "Rinomina",
    reclining: "Ribaltabile",
    remove: "Rimuovi",
    removeImage: "Rimuovi immagine",
    reinforcedRailRequired: "Corrimano rinforzato richiesto",
    reset: "Reimposta",
    resetToDefault: "Reimposta ai valori predefiniti",
    resourceNotFound: "La risorsa da lei cercata non è stata trovata.",
    right: "Destra",
    save: "Salva",
    saved: "Salvato",
    draft: "Bozza",
    search: "Cerca",
    select: "Seleziona",
    selectProject: "Seleziona progetto",
    selectProjectFirst: "Selezionare prima un progetto",
    selectProjectInwhichCreateCopy: "Seleziona il progetto nel quale creare la copia",
    sessionExpired: "Sessione scaduta",
    sessionExpiredText: "Accedi di nuovo per continuare a utilizzare l'applicazione.",
    settings: "Impostazioni",
    status: "Stato",
    straight: "Dritto",
    sync: "Sync",
    targa: "Targa",
    testEnvironment: "Ambiente di test",
    toBeInstalled: "Da installare",
    toInspect: "Da ispezionare",
    uploadedAt: "Caricato",
    uploadedBy: "Caricato da",
    upperHoleDiameter: "Diametro del foro superiore",
    upperSupport: "Supporto superiore",
    value: "Valore",
    visible: "Visibile",
    yes: "Si",
    youAreNotAllowed: "Non sei autorizzato ad accedere a questa risorsa.",
    youCannotMixUpSubstructureHeightSizeAndThickness:
      "Non è possibile mescolare altezza della sottostruttura, dimensione e spessore della piastra metallica.",
    youCannotMixUpSubstructureMaxSpanAndMaxInsulationThickness:
      "Non è possibile mescolare la luce massima della sottostruttura e lo spessore massimo dell'isolante.",
    canBeCustom: "Può essere personalizzato",
    canBeMultiple: "Può essere multiplo",
    categories: "Categorie",
    codeItem: "Codice elemento",
    codeExtraItem: "Codice elemento aggiuntivo",
    components: "Componenti",
    curves: "Curve",
    draw: "Disegna",
    excludedItems: "Elementi esclusi",
    extensions: "Estensioni",
    extras: "Extra",
    flatRoofCompatible: "Compatibile tetto piano",
    hasHips: "Ha colmi",
    height: "Altezza",
    image: "Immagine",
    hipLength: "Lunghezza colmo",
    hipsSpan: "Luce colmi",
    hipsSpanRequired: "Luce colmi richiesta",
    insulationThickness: "Spessore isolamento",
    insulationThicknessRequired: "Spessore isolamento richiesto",
    intermediates: "Intermedi",
    isFlat: "È piano",
    isLifeLine: "È linea vita",
    length: "Lunghezza",
    loop: "Anello",
    mappings: "Mappature",
    max: "Massimo",
    maxInsulationThickness: "Spessore massimo isolamento",
    maxPitch: "Pendenza massima",
    maxSpan: "Luce massima",
    maxThickness: "Spessore massimo",
    maxUsers: "Utenti massimi",
    min: "Minimo",
    minMetalPlateThickness: "Spessore minimo piastra metallica",
    minSubstructureHeight: "Altezza minima sottostruttura",
    minSubstructureSize: "Dimensione minima sottostruttura",
    minThickness: "Spessore minimo",
    minCurbHeight: "Altezza minima cordolo",
    minHeight: "Altezza minima",
    minSpan: "Luce minima",
    minValue: "Valore minimo",
    minWidth: "Larghezza minima",
    notLoop: "Non anello",
    notRightAngle: "Non angolo retto",
    nrOfShuttlesForLifeLines: "Numero di navette per linee vita",
    nrOfShuttlesRequestted: "Numero di navette richiesto",
    perimeter: "Perimetro",
    closedPerimeter: "Perimetro chiuso",
    perimeterLength: "Lunghezza totale del perimetro",
    perimeterLengthParallel: "Lunghezza parallela alla greca",
    perimeterLengthPerpendicular: "Lunghezza perpendicolare alla greca",
    cornerCountTotal: "Numero totale di angoli",
    cornerCountInternal: "Numero di angoli interni",
    cornerCountExternal: "Numero di angoli esterni",
    parallel: "Parallelo",
    perpendicular: "Perpendicolare",
    internal: "Interno",
    external: "Esterno",
    pitch: "Pendenza",
    pleaseSpecifyAHeight: "Si prega di specificare un'altezza",
    pleaseSpecifyAWidth: "Si prega di specificare una larghezza",
    pleaseSpecifyHeightAndWidth: (height: number, width: number, unit: string) =>
      ` Si prega di specificare (altezza)x(larghezza): ${height}x${width} ${unit}`,
    rightAngle: "Angolo retto",
    roof: "Tetto",
    roofInfo: "Tetto",
    roofs: "Tetti",
    roofWeight: "Peso tetto",
    roofWeightRequired: "Peso tetto richiesto",
    seamHeight: "Altezza aggraffatura",
    seamHeightRequired: "Altezza aggraffatura richiesta",
    seamsSpan: "Luce aggraffature",
    seamsSpanRequired: "Luce aggraffature richiesta",
    sheetMaterialRequired: "Materiale lamiera richiesto",
    span: "Luce",
    stepHeightRequired: "Altezza gradino richiesta",
    substructureHeight: "Altezza sottostruttura",
    substructures: "Sottostrutture",
    substructureSize: "Dimensione sottostruttura",
    supports: "Supporti",
    supportHeight: "Altezza supporto",
    supportMaterialRequired: "Materiale supporto richiesto",
    supportSelection: "Selezione supporto",
    type: "Tipo",
    types: "Tipi",
    caps: "Tappi",
    useOnlyAnchorPoints: "Usa solo punti di ancoraggio",
    wallFixings: "Fissaggi a parete",
    waveSpan: "Luce onda",
    waveSpanRequired: "Luce onda richiesta",
    width: "Larghezza",
    componentMaterial: "Materiale componente",
    componentMaterials: "Materiali componenti",
    lifeLineAnchors: "Ancoraggi linea vita",
    absorberAllowsMaxNUsers: (n: number) => `L'assorbitore permette massimo ${n} utenti`,
    metalPlateThickness: "Spessore piastra metallica",
    supportIntermediateElement: "Elemento intermedio supporto",
    supportIntermediateElements: "Elementi intermedi supporto",
    supportTerminalCurve: "Curva terminale supporto",
    extraItem: "Elemento extra",
    forLoop: "Per anello",
    forNotLoop: "Per non anello",
    invitationHasBeenSentSuccessfully: "Invito inviato con successo.",
    invite: "Invita",
    invitePage: {
      fallbackAuthorName: "un membro del team",
      invitedBy: "Invitato da",
      invitationSentTo: "Invito inviato a",
      description: "Descrizione",
      notAvailable: "Non disponibile",
      acceptAction: "Accetta invito",
      rejectAction: "Rifiuta invito",
      notFoundTitle: "Invito non trovato",
    },
    isAnchorPoint: "È punto di ancoraggio",
    stepHeight: "Altezza gradino",
    addPoints: "Aggiungi punti",
    angle: "Angolo",
    angles: "Angoli",
    bottomClamp: "Morsetto inferiore",
    bottomItems: "Elementi inferiori",
    clamped: "Bloccato",
    clampThickness: "Spessore morsetto",
    curve: "Curva",
    default: "Predefinito",
    defaultPitch: "Pendenza predefinita",
    degrees: "Gradi",
    editCurve: "Modifica curva",
    editPatrolComponent: "Modifica componente Patrol",
    editTerminal: "Modifica terminale",
    erease: "Cancella",
    factor: "Fattore",
    finish: "Fine",
    forTerminalsAndCurves: "Per terminali e curve",
    forIntermediates: "Per intermedi",
    globalSettings: "Impostazioni globali",
    help: "Aiuto",
    hide: "Nascondi",
    hipsSpans: "Luci colmi",
    includeSelectedComponent: "Includi componente selezionato",
    includeTarga: "Includi targa",
    intermediate: "Intermedio",
    intersectionPoint: "Punto di intersezione",
    isClampable: "È bloccabile",
    isSubstructureIndependent: "È indipendente dalla sottostruttura",
    lifeLine: "Linea vita",
    lifeLinePlusAnchorPoint: "Linea vita + punto di ancoraggio",
    lifeLinesAndAnchorPointsHaveBeenFound_message:
      "Sono state trovate linee vita e punti di ancoraggio. Per modificare i parametri del tetto, è necessario eliminare questi dati. Clicca su 'Elimina' per rimuoverli e sbloccare il modulo",
    lifeLineSegment: "Segmento linea vita",
    maxAngle: "Angolo massimo",
    maxCornersPerLifeline: "Angoli massimi per linea vita",
    maxHeight: "Altezza massima",
    maxSeamsSpan: "Luce massima aggraffature",
    maxSpanBetweenCurveAndIntermediate: "Luce massima tra curva e intermedio",
    maxSpanBetweenIntermediate: "Luce massima tra intermedi",
    minAngle: "Angolo minimo",
    minSpanBetweenSupports: "Luce minima tra supporti",
    minPitch: "Pendenza minima",
    noAdditionalPost: "Nessun montante aggiuntivo",
    normativeDetails: "Dettagli normativi",
    onlyAnchorPoint: "Solo punto di ancoraggio",
    onlyFor: "Solo per",
    onlyLifeLine: "Solo linea vita",
    optionals: "Opzionali",
    pitchMinMaxDefault: "Pendenza min/max/predefinita",
    pleaseSpecifyAMaxHeight: "Si prega di specificare un'altezza massima",
    pleaseSpecifyAMinHeight: "Si prega di specificare un'altezza minima",
    pleaseSpecifyAValueBetween: (min: number, max: number | null, unit: string) =>
      `Si prega di specificare un valore tra ${min} e ${max} ${unit}`,
    searchIntermediatedCurves: "Cerca curve intermedie",
    selectedComponent: "Componente selezionato",
    show: "Mostra",
    spans: "Luci",
    splitLifeLineHere: "Dividi linea vita qui",
    stepHeightRange: "Intervallo altezza gradino",
    support: "Supporto",
    supportCurve: "Curva supporto",
    supportTerminal: "Terminale supporto",
    supportTerminalAndCurve: "Terminale e curva supporto",
    terminal: "Terminale",
    terminal_plus_intermediate: "Terminale + intermedio",
    terminalAndCurve: "Terminale e curva",
    terminalCurves: "Curve terminali",
    terminalCurveAndIntermediate: "Curva terminale e intermedio",
    termsAndConditions: "Termini e Condizioni",
    theMaximumAllowedValueIs: (value: number) => `Il valore massimo consentito è ${value}°`,
    theMinimumAllowedValueIs: (value: number) => `Il valore minimo consentito è ${value}`,
    theMaximulAllowedLifeLineLengthExceeds: (
      meters: number,
      curves: number,
      maxLength: number,
      allowedLength: number,
    ) =>
      `La linea di sicurezza del segmento selezionato ha una lunghezza di ${meters} metri. A causa delle ${curves} curve, la lunghezza massima consentita di ${maxLength} metri è ridotta a ${allowedLength}. Si prega di dividere la linea.`,
    theMinAngleIfIntermediateAndTerminalforTheSystemIs_degrees: (degrees: number) =>
      `Il sistema selezionato non permette curve con un angolo inferiore a ${degrees}°.`,
    theMinAngleOfCurveForTheSystemIs_degrees: (degrees: number) =>
      `Il sistema selezionato con intersezione (terminal e intermedio) permette solo una linea quasi rettilinea (minimo ${degrees}°).`,
    theSystemRequiresAMinSpanOfXMeters: (minSpan: number) =>
      `Il sistema richiede una distanza minima di ${minSpan} metri.`,
    topClamp: "Morsetto superiore",
    topExtraItem: "Elemento extra superiore",
    topItem: "Elemento superiore",
    unlock: "Sblocca",
    unshare: "Rimuovi condivisione",
    update: "Aggiorna",
    versions: "Versioni",
    warningThisEditCouldAffectOtherSystemsAsWell:
      "Attenzione: questa modifica potrebbe influenzare anche altri sistemi",
    from: "Da",
    meters: "Metri",
    terminal_plus_terminal: "Terminale + terminale",
    to: "A",
    defaultSupports: "Supporti di base",
    supportRequired: "Supporto necessario",
    supportsHeight: "Altezza dei supporti",
  },
  elements: {
    createNew: "Crea nuovo elemento",
    delete: "Elimina elemento",
    edit: "Modifica elemento",
    singular: "Elemento",
    plural: "Elementi",
    search: "Cerca elementi",
    questions: {
      delete: "Vuoi davvero eliminare questo elemento?",
    },
    errors: {
      alreadyPresent: "Elemento già presente",
      notFound: "Elemento non trovato",
      inUseByConfiguration: "L'elemento è ancora in uso in una configurazione",
    },
  },
  terminals: {
    createNew: "Crea nuovo terminale",
    delete: "Elimina terminale",
    edit: "Modifica terminale",
    singular: "Terminale",
    plural: "Terminali",
    search: "Cerca terminali",
    questions: {
      delete: "Vuoi davvero eliminare questo terminale?",
    },
    errors: {
      alreadyPresent: "Terminale già presente",
      notFound: "Terminale non trovato",
      inUseByConfiguration: "Il terminale è ancora in uso in una configurazione",
    },
  },
  roofTypes: {
    createNew: "Crea nuovo tipo di tetto",
    delete: "Elimina tipo di tetto",
    singular: "Tipo di tetto",
    plural: "Tipi di tetto",
    search: "Cerca tipi di tetto",
    questions: {
      delete: "Vuoi davvero eliminare questo tipo di tetto?",
    },
    errors: {
      pleaseSelectRoofType: "Si prega di selezionare un tipo di tetto",
    },
  },
  roofCategories: {
    createNew: "Crea nuova categoria di tetto",
    delete: "Elimina categoria di tetto",
    singular: "Categoria di tetto",
    plural: "Categorie di tetto",
    search: "Cerca categorie di tetto",
    questions: {
      delete: "Vuoi davvero eliminare questa categoria di tetto?",
    },
    errors: {
      pleaseSelectRoofCategory: "Si prega di selezionare una categoria di tetto",
      inUseByRoofType: "La categoria è ancora in uso in un tipo di tetto",
    },
  },
  roofMaterials: {
    createNew: "Crea nuovo materiale tetto",
    delete: "Elimina materiale tetto",
    singular: "Materiale tetto",
    plural: "Materiali tetto",
    search: "Cerca materiali tetto",
    questions: {
      delete: "Vuoi davvero eliminare questo materiale tetto?",
    },
  },
  materials: {
    createNew: "Crea nuovo materiale",
    delete: "Elimina materiale",
    singular: "Materiale",
    plural: "Materiali",
    search: "Cerca materiali",
    questions: {
      delete: "Vuoi davvero eliminare questo materiale?",
    },
  },
  roofSubstructures: {
    createNew: "Crea nuova sottostruttura tetto",
    delete: "Elimina sottostruttura tetto",
    singular: "Sottostruttura tetto",
    single: "Sottostruttura tetto",
    plural: "Sottostrutture tetto",
    search: "Cerca sottostrutture tetto",
    questions: {
      delete: "Vuoi davvero eliminare questa sottostruttura tetto?",
    },
  },
  sheetMaterials: {
    createNew: "Crea nuovo materiale lamiera",
    delete: "Elimina materiale lamiera",
    edit: "Modifica materiale lamiera",
    singular: "Materiale lamiera",
    plural: "Materiali lamiera",
    search: "Cerca materiali lamiera",
    questions: {
      delete: "Vuoi davvero eliminare questo materiale lamiera?",
    },
  },
  patrolSystems: {
    createNew: "Crea nuovo sistema Patrol",
    delete: "Elimina sistema Patrol",
    singular: "Sistema Patrol",
    plural: "Sistemi Patrol",
    search: "Cerca sistemi Patrol",
    questions: {
      delete: "Vuoi davvero eliminare questo sistema Patrol?",
    },
  },
  patrolSystemMappings: {
    createNew: "Crea nuova mappatura sistema Patrol",
    delete: "Elimina mappatura sistema Patrol",
    edit: "Modifica mappatura sistema Patrol",
    singular: "Mappatura sistema Patrol",
    plural: "Mappature sistema Patrol",
    search: "Cerca mappature sistema Patrol",
    questions: {
      delete: "Vuoi davvero eliminare questa mappatura sistema Patrol?",
    },
  },
  systemNormatives: {
    createNew: "Crea nuova normativa sistema",
    delete: "Elimina normativa sistema",
    edit: "Modifica normativa sistema",
    singular: "Normativa sistema",
    plural: "Normative sistema",
    search: "Cerca normative sistema",
    questions: {
      delete: "Vuoi davvero eliminare questa normativa sistema?",
    },

    errors: {
      normativeAlreadyPresent: "La normativa selezionata è già associata al sistema.",
    },
  },
  uprightSpanMappings: {
    createNew: "Crea nuova mappatura luce montante",
    delete: "Elimina mappatura luce montante",
    edit: "Modifica mappatura luce montante",
    singular: "Mappatura luce montante",
    plural: "Mappature luce montante",
    search: "Cerca mappature luce montante",
    questions: {
      delete: "Vuoi davvero eliminare questa mappatura luce montante?",
    },
    errors: {
      alreadyPresent: "Mappatura luce montante già presente",
      updateNotAllowed: "Non sei autorizzato ad aggiornare questa mappatura luce montante.",
    },
  },
  uprightMappings: {
    createNew: "Crea nuova mappatura montante",
    delete: "Elimina mappatura montante",
    edit: "Modifica mappatura montante",
    singular: "Mappatura montante",
    plural: "Mappature montante",
    search: "Cerca mappature montante",
    questions: {
      delete: "Vuoi davvero eliminare questa mappatura montante?",
    },
    errors: {
      alreadyPresent: "Mappatura montante già presente",
    },
  },
  patrolAnchorMappings: {
    createNew: "Crea nuova mappatura ancoraggio Patrol",
    delete: "Elimina mappatura ancoraggio Patrol",
    edit: "Modifica mappatura ancoraggio Patrol",
    singular: "Mappatura ancoraggio Patrol",
    plural: "Mappature ancoraggio Patrol",
    search: "Cerca mappature ancoraggio Patrol",
    questions: {
      delete: "Vuoi davvero eliminare questa mappatura ancoraggio Patrol?",
    },
  },
  membranes: {
    createNew: "Crea nuova membrana",
    delete: "Elimina membrana",
    singular: "Membrana",
    plural: "Membrane",
    search: "Cerca membrane",
    questions: {
      delete: "Vuoi davvero eliminare questa membrana?",
    },
    single: "Membrana",
  },
  patrolSupports: {
    createNew: "Crea nuovo supporto Patrol",
    delete: "Elimina supporto Patrol",
    edit: "Modifica supporto Patrol",
    singular: "Supporto Patrol",
    plural: "Supporti Patrol",
    search: "Cerca supporti Patrol",
    questions: {
      delete: "Vuoi davvero eliminare questo supporto Patrol?",
    },
  },
  itemNormativeExclusions: {
    add: "Aggiungi esclusione normativa elemento",
    createNew: "Crea nuova esclusione normativa elemento",
    delete: "Elimina esclusione normativa elemento",
    edit: "Modifica esclusione normativa elemento",
    singular: "Esclusione normativa elemento",
    plural: "Esclusioni normative elementi",
    search: "Cerca esclusioni normative elementi",
    questions: {
      remove: "Vuoi davvero rimuovere questa esclusione normativa elemento?",
    },
    errors: {
      notFound: "Esclusione normativa elemento non trovata",
    },
  },
  supportExtensions: {
    createNew: "Crea nuova estensione supporto",
    delete: "Elimina estensione supporto",
    edit: "Modifica estensione supporto",
    singular: "Estensione supporto",
    plural: "Estensioni supporto",
    search: "Cerca estensioni supporto",
    questions: {
      delete: "Vuoi davvero eliminare questo supporto?",
    },
  },
  supportExtras: {
    createNew: "Crea nuovo extra supporto",
    delete: "Elimina extra supporto",
    edit: "Modifica extra supporto",
    singular: "Extra supporto",
    plural: "Extra supporti",
    search: "Cerca extra supporti",
    questions: {
      delete: "Vuoi davvero eliminare questo extra supporto?",
    },
  },
  supportOptionals: {
    createNew: "Crea nuovo supporto opzionale",
    delete: "Elimina supporto opzionale",
    edit: "Modifica supporto opzionale",
    singular: "Supporto opzionale",
    plural: "Supporti opzionali",
    search: "Cerca supporti opzionali",
    questions: {
      delete: "Vuoi davvero eliminare questo supporto opzionale?",
    },
  },
  clampings: {
    createNew: "Crea nuovo serraggio",
    edit: "Modifica serraggio",
    delete: "Elimina serraggio",
    singular: "Serraggio",
    plural: "Serraggi",
    search: "Cerca serraggi",
    questions: {
      delete: "Vuoi davvero eliminare questo serraggio?",
    },
    errors: {
      notFound: "Serraggio non trovato",
      inUseByConfiguration: "Il serraggio è ancora in uso in una configurazione",
    },
  },
  patrolCurveIntermediates: {
    singular: "Curva/Intermedio Patrol",
    plural: "Curve/Intermedi Patrol",
    createNew: "Crea nuova curva/intermedio Patrol",
    delete: "Elimina curva/intermedio Patrol",
    edit: "Modifica curva/intermedio Patrol",
    search: "Cerca curve/intermedi Patrol",
    questions: {
      delete: "Vuoi davvero eliminare questa curva/intermedio Patrol?",
    },
  },
  normativeVersions: {
    singular: "Versione normativa",
    plural: "Versioni normative",
    add: "Aggiungi versione normativa",
    createNew: "Crea nuova versione normativa",
    errors: {
      atLeastOneSystemRequired: "È richiesto almeno un sistema",
    },
  },
  anchorPoints: {
    addNew: "Aggiungi nuovi punti di ancoraggio",
    singular: "Punto di ancoraggio",
    plural: "Punti di ancoraggio",
    delete: "Elimina punto di ancoraggio",
    hide: "Nascondi punti di ancoraggio",
    show: "Mostra punti di ancoraggio",
    questions: {
      delete: "Vuoi davvero eliminare il punto di ancoraggio selezionato?",
    },
  },
  accessPoints: {
    addNew: "Aggiungi nuovi punti di accesso",
    singular: "Punto di accesso",
    delete: "Elimina punto di accesso",
    questions: {
      delete: "Vuoi davvero eliminare il punto di accesso selezionato?",
    },
  },
  lifeLines: {
    draw: "Disegna linea vita",
    singular: "Linea vita",
    plural: "Linee vita",
    delete: "Elimina linea vita",
    hide: "Nascondi linee vita",
    show: "Mostra linee vita",
    questions: {
      deleteEdge: "Vuoi davvero eliminare il segmento selezionato?",
      deleteNode: "Vuoi davvero eliminare il punto di intersezione selezionato?",
    },
    errors: {
      creatingCrossIntersectionsNotAllowed: "Non è consentito creare intersezioni a croce a quattro punti",
      loopsNotAllowed: "Il sistema selezionato non permette loop.",
      intersectionsNotAllowed: "Il sistema selezionato non permette intersezioni a 3 vie.",
      systemDoesNotAllowMoreThanXCorners: (maxCorners: number) =>
        `Il sistema selezionato non permette più di ${maxCorners} angoli`,
    },
  },
};

export default it;
